export interface AttomAdditionalInfo {
  year?: string;
  sqft?: string;
  lot?: string;
  attomId?: number;
}
